import React,{useEffect, useState} from 'react';
import { useTranslation } from "react-i18next";
import "@/app/pages/companyProfile/companyLinkage/CompanyLinkage.scss";
import { checkSupression } from "@/utils/index";

const CompanyLinkage = ({ props }): JSX.Element => {
    const { t } = useTranslation();

    return (
      <>
        <div className="company-linkage-container">
          <div className="company-linkage-wrapper">
            <div className="company-linkage-parent-container">
              <div className="company-linkage-overview">
                <div className="company-linkage-row">
                  <div className="col-md-12">
                    <div className="company-linkage-section">
                    <div className="company-linkage-text">
                      Get full access to D&amp;B Hoovers
                    </div>
                    <div className="company-linkage-description">
                    With a Hoovers subscription you can get a comprehensive view of {props?.primaryName}
                    </div>
                    <div className="company-linkage-business-name">
                   {props?.primaryName}<sup>*</sup>
                    </div>
                    </div>
                    <div className="company-principals-relations-container">
                        {(props?.totalPrincipals != 0 && props?.totalPrincipals) && ( <div className="linkage-sub-container">
                          <div className="company-total-principals">{props?.totalPrincipals}</div>
                          <div className="principals-heading">{t("companyProfile.corporateLinkage.principalsTitle")}</div>
                          <div className="principals-text">
                            {t("companyProfile.corporateLinkage.principalsText")}
                          </div>
                        </div>)}
                       {(props?.totalCorporateFamilyMembers != 0 && props?.totalCorporateFamilyMembers) && (<div className="linkage-sub-container">        
                                  <span className='linkage-check' data-tracking-name={t("companyProfile.corporateLinkage.corporateRelations")}>
                                  {checkSupression(props?.totalCorporateFamilyMembers)}
                                  </span>
                              
                              <div className="principals-heading" data-tracking-name="Corporate Relations">
                              {t("companyProfile.corporateLinkage.corporateRelations")}
                              </div>
                              <div className="principals-text">
                              {t("companyProfile.corporateLinkage.corporateRelationsText")}
                              </div>
                        </div>)}

                          {(props?.closeIndustryPeers != 0 && props?.closeIndustryPeers) && ( <div className="linkage-sub-container">
                            <div className="company-total-principals">{props?.closeIndustryPeers}</div>
                            <div className="principals-heading">{t("companyProfile.corporateLinkage.industryPeers")}</div>
                            <div className="principals-text">
                              {t("companyProfile.corporateLinkage.industryInsights")}
                            </div>
                          </div> )}
                    </div>
                    <div className="linkage-trial">
                    <div>
                      <a
                        className="linkage-button"
                        href={t("companyProfile.corporateLinkage.companyLinkageCtaLinkPath")}
                      >
                        Start Your Free Trial
                      </a>
                    </div>
                    <div className="principals-text">
                      *Contacts and Principals counts are estimates and may
                      differ from the actual number of contacts available in
                      D&amp;B Hoovers.
                    </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
}

export default CompanyLinkage;